import { UnifiedShellFrame, useInUnifiedShellFrame } from '@upright/ui/views/unified-shell/unified-shell-frame';
import { useUnifiedEntityFrameActive } from '@upright/ui/views/unified-shell/use-unified-entity-frame-active';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { BouSpacingLevel, fluidVerticalMargin } from '../../../layout/bou-spacing';
import { BouPageWithFrame } from '../../../layout/bou-tool-page-with-frame';
import { BouSpinnerSize } from './bou-spinner';
import { CenteredSpinner } from './centered-spinner';

/**
 * Loading for a page
 */

interface Props {
  sideBarContent?: ReactNode;
  hideSideBar?: boolean;
}

export function BouToolPageLoading(props: Props) {
  const insideUnifiedFrame = useInUnifiedShellFrame();
  const unifiedEntityFrame = useUnifiedEntityFrameActive();
  // we are assuming that header with logo is visible, so
  // we don't want to duplicate the logo
  const showLogo = false;

  // On an entity route in the unified shell the header switch paints no bar, so the page's loading
  // state brings the shell's frame, and inside that frame (a drilldown's table loading) only the
  // spinner: a legacy frame there would cover the shell.
  if (insideUnifiedFrame) return <StyledSpinner size={BouSpinnerSize.MEDIUM} showLogo={showLogo} />;
  if (unifiedEntityFrame.active) return <UnifiedShellFrame suspended />;
  if (unifiedEntityFrame.loading) return <StyledSpinner size={BouSpinnerSize.MEDIUM} showLogo={showLogo} />;

  return (
    <Root>
      <BouPageWithFrame sideBarContent={props.sideBarContent || <></>} hideSideBar={props.hideSideBar}>
        <StyledSpinner size={BouSpinnerSize.MEDIUM} showLogo={showLogo} />
      </BouPageWithFrame>
    </Root>
  );
}

const Root = styled.div`
  ${fluidVerticalMargin(BouSpacingLevel.MEDIUM)}
`;

const StyledSpinner = styled(CenteredSpinner)`
  margin-top: 30px;
`;
